export const IVIDEON_DEALER_REGISTRY = [
  "id",
  "code",
  "name",
  "city",
  "address",
  "category",
  "status",
  "checkStatus",
  "owner",
  "serviceCameras",
  "saleCameras",
  "serviceCheck",
  "saleCheck",
  "ivideonAuth",
  "extendedForNextYear",
];
